import PropTypes from 'prop-types';

export const StudentIntakeElementKind = {
    head: "HEAD", // Deprecated
    header: "HEADER",
    instruction: "INSTRUCTION",
    text: "TEXT", // Deprecated
    question: "QUESTION"
};

export const IntakeElementType = PropTypes.shape({
    displayType: PropTypes.string,
    questionId: PropTypes.number.isRequired,
    kind: PropTypes.string.isRequired,
    options: PropTypes.array,
    retired: PropTypes.bool,
    id: PropTypes.number.isRequired,
    text: PropTypes.string,
    type: PropTypes.string.isRequired,
    value: PropTypes.any,
    required: PropTypes.bool
});
